/* rr-lab-therm, bloc 03 « Le chaud et le froid ».
   Remplace le champ thermique d'origine, qui dépendait de la photo de la pièce
   et rendait une image noire, par une scène dessinée : fenêtre nue à gauche,
   rideau fermé à droite. Palette ironbow et échelle 6 → 23 °C inchangées ; la
   sonde au survol et les trois repères continuent de lire ce même champ. */
(function () {
  if (!window.customElements) return;
  customElements.whenDefined('rr-lab').then(function () {
    var K = customElements.get('rr-lab');
    if (!K || K.__therm) return;
    K.__therm = true;

    var GW = 180, GH = 120;
    var WX0 = .233, WX1 = .767, WY0 = .142, WY1 = .733;   /* dormant */
    var GX0 = .254, GX1 = .746, GY0 = .173, GY1 = .702;   /* vitrage */
    var CX0 = .177, CX1 = .823, CY0 = .122, CY1 = .982;   /* rideau  */
    function cl(v, a, b) { return v < a ? a : (v > b ? b : v); }

    /* la scène ne dépend plus de la photo de la pièce */
    K.prototype.lumFromImage = function () { this.lumGrid = null; this.edges = null; };

    K.prototype.field = function (withC) {
      var out = new Float32Array(GW * GH), dbl = this.kind === 'double';
      for (var j = 0; j < GH; j++) for (var i = 0; i < GW; i++) {
        var u = (i + .5) / GW, v = (j + .5) / GH, k = j * GW + i;
        var T = 19.6 + (1 - v) * 0.5 + Math.sin(u * 5.81) * 0.12;
        if (v > 0.80) T = 19.0 - (v - 0.80) * 1.2;

        var inFrame = u > WX0 && u < WX1 && v > WY0 && v < WY1;
        var inGlass = u > GX0 && u < GX1 && v > GY0 && v < GY1;

        if (inFrame) T = 14.6;
        if (inGlass) {
          var gy = (v - GY0) / (GY1 - GY0);
          var e = cl(Math.min((u - GX0) / .0444, (GX1 - u) / .0444,
                              (v - GY0) / .0667, (GY1 - v) / .0667), 0, 1);
          T = 11.4 - gy * 1.9 - (1 - e) * 1.7;
        }
        if (inFrame && Math.abs(u - .5) < .009) T = 14.2;
        if (!inFrame && u > WX0 - .026 && u < WX1 + .026 && v > WY0 - .038 && v < WY1 + .038) T -= 2.3;
        if (u > WX0 - .019 && u < WX1 + .019 && v > WY1 && v < WY1 + .033) T = 15.4;

        if (!withC) {
          if (v > WY1 && u > WX0 - .03 && u < WX1 + .03) {
            var d = cl((v - WY1) / .317, 0, 1);
            var lat = Math.pow(cl(1 - Math.abs(u - .5) / .344, 0, 1), .6);
            T -= 5.6 * Math.pow(1 - d, 1.5) * lat;
          }
          if (v > 0.80 && u > WX0 - .106 && u < WX1 + .106) {
            var dd = cl((v - 0.80) / .158, 0, 1);
            T -= 3.4 * (1 - dd) * cl(1 - Math.abs(u - .5) / .389, 0, 1);
          }
        } else {
          if (u > CX0 - .031 && u < CX1 + .031 && Math.abs(v - .107) < .010) T = 17.2;
          if (u > CX0 && u < CX1 && v > CY0 && v < CY1) {
            var cy = (v - CY0) / (CY1 - CY0);
            var b = (dbl ? 19.3 : 18.55) - cy * 1.05 - cl((cy - .86) / .14, 0, 1) * 2.4;
            var f = Math.sin(u * 43.9 + Math.sin(u * 12) * 1.1) * 0.95 + Math.sin(u * 104) * 0.22;
            b += f * (0.7 + 0.3 * cy);
            b -= cl(1 - (v - CY0) / .052, 0, 1) * (dbl ? 1.6 : 2.1);
            b -= cl(1 - Math.min(u - CX0, CX1 - u) / .030, 0, 1) * (dbl ? 1.4 : 1.9);
            T = b;
          }
          if (v > 0.80 && u > CX0 - .047 && u < CX1 + .047) T -= 0.5;
        }
        out[k] = T + (Math.random() - .5) * 0.10;
      }
      return out;
    };

    /* repères recalés : vitrage et fuites d'air à gauche du curseur, menuiserie à
       droite, et tous les trois à l'écart de la poignée centrale */
    var PINS = [[.355, .42], [.72, .165], [.40, .855]];
    document.querySelectorAll('rr-lab').forEach(function (el) {
      if (!el.pins) return;
      el.pins.forEach(function (p, i) {
        p.u = PINS[i][0]; p.v = PINS[i][1];
        p.el.style.left = (p.u * 100) + '%';
        p.el.style.top = (p.v * 100) + '%';
      });
      el.split = .5;
      var st = el.querySelector('[data-t-stage]');
      var rg = el.querySelector('[data-t-range]');
      if (st) st.style.setProperty('--x', '50%');
      if (rg) rg.value = 50;
      el.buildThermal();
    });
  });
})();
